import React from 'react'

const CashFlow = () => {
  return (
    <div>
      CashFlow
    </div>
  )
}

export default CashFlow
